import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useRouter } from "next/compat/router";
import styles from "./Header.module.scss";
import TopBanner from "./TopBanner";
import DesktopMainHeader from "./DesktopMainHeader";
import MobileMainHeader from "./MobileMainHeader";
import SearchComp from "../SearchComp";
import TopLinks from "./TopLinks";
import { MenuBuilder } from "../BuilderIO/Menu/Menu.builder";
import { getShopMetaData } from "@/helpers/generalHelper";
import MenuIcon from "@/components/Logos/Menu";
import { generateBadge } from "@/helpers/pdpHelpers/badgeHelpers";

import {
  initializeCauseData,
  setDefaultCause,
} from "../../redux/actions/generalAction";
import {
  createOrGetWishlist,
  getWishlistProducts,
  getNumberId,
} from "@/helpers/wishlistHelpers";
import { initializeWishlist, setWishlistLoadingState } from "@/redux/actions/wishlistAction";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { isHeaderScroll } from "@/redux/actions/headerAction";
import { navigationTracking } from "@/components/common/Tracking";
import {
  addToCart,
  openMiniCart, 
  } from "@/redux/actions/addToCartAction";
import { addProductToCart } from "@/helpers/cartHelpers";
import AccountSidebar from "./Account/AccountSidebar";
import { getProductData, getProductVariant } from "@/helpers/productHelper";
import { pushAddToCartEvent } from "@/helpers/cartEventHelper";
import { setGroupShipDate } from "@/helpers/checkout-shipping/checkoutShippingHelper";

export default function HeaderComp() {
  const lowerHeaderZIndex = useSelector(
    (state) => state.header.lowerHeaderZIndex
  );
  const superBrandHeroPresent = useSelector(
    (state) => state.header.isSuperbrandHeroPresent
  );
  const isMenuVisible = useSelector(
    (state) => state.header.isMenuVisible
  );
  const wishlistSidebarOpen = useSelector(
    (state) => state.wishlist.open_wishlist_sidebar
  );
  const scrollPos = useSelector((state) => state.drawer.scrollPos);
  
  const basketSidebarOpen = useSelector((state) => state.click.open_mini_cart);
  const [scroll, setScroll] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [searchActive, setSearchActive] = useState(false);
  const [activeTopLink, setActiveTopLink] = useState(0);
  const [displayMainMenu, setDisplayMainMenu] = useState(true);
  const destopHeaderRef = useRef(null);
  const mobileHeaderRef = useRef(null);
  const nostoRef = useRef(null);
  const selectIcon = async (ele) => {
    setSelectedIcon(ele);
  };
  const searchRef = useRef();
  const dispatch = useDispatch();
  const isMobileOrBelow = useMediaQuery("(max-width: 767px)")
  // Initialize wishlist data in redux
  const userId = useSelector((state) => state.loginUser.userData?.id);
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const userLoggedIn = useSelector((state) => state.loginUser.userLoggedIn);
  const checkPwaGuest = useSelector((state) => state.pwa.is_guest);
  const accountSidebarOpen = useSelector(
    (state) => state.loginUser.open_account_sidebar
  );
  const [showWcJourney, setShowWcJourney] = useState(true);
  const welcomeStep = useSelector((state) => state.pwa.step);
  // check if search icon is already clicked
  const isSearchIcon = useSelector((state) => state.header.setIconSearch);
  const navSidebarOpen = useSelector((state) => state.header.isMenuVisible);
  let logUser = useSelector((state) => state.loginUser);
  const router = useRouter();
  const [accountColor, setAccountColor]=useState();

  function handleSetAccountColor(val){
    setAccountColor(val);
  }

  useEffect(() => {
      window.addEventListener("scroll", () => {
        if(isPWA) {
          setScroll(window.scrollY > 0);
        }else {
          setScroll(window.scrollY > 50);
        }
        
      });
      //Scroll to position only for mobile view using scrollPos in redux
      if(isMobileOrBelow){
        window.scrollTo({
        top: scrollPos,
        });
      }
  }, [isMenuVisible, wishlistSidebarOpen, basketSidebarOpen, accountSidebarOpen]);

  useEffect(() => {
    (async () => {
      const { causeList, defaultCause } = await getShopMetaData();
      dispatch(initializeCauseData(causeList));
      dispatch(setDefaultCause(defaultCause));
    })();

    if (userId) {
      if (typeof yotpoWidgetsContainer != "undefined" && typeof yotpoWidgetsContainer != undefined) {
        yotpoWidgetsContainer.initWidgets();
      }
    }
  }, []);

  useEffect(() => {
    if (!isPWA && selectedIcon !== "search") {
      setSearchActive(false);
    }
    //  if icon is aleady selected
    if (isPWA && isSearchIcon) {
      setSearchActive(true);
    }
    // if (isPWA && !isSearchIcon && !navSidebarOpen) {
    //   setSearchActive(false);
    // }
  }, [selectedIcon]);

  useEffect(() => {
    let body = document.body;
    if (searchActive) {
      body.classList.add("active__search");
      body.classList.remove("close__search");
      searchRef.current.scrollTo(0, 0);
    } else {
      body.classList.remove("active__search");
      body.classList.add("close__search");
      setSelectedIcon(null);
    }
  }, [searchActive]);

  // When scrolled: hide main menu and if top links are clicked unhide main menu (Desktop)
  useEffect(() => {
    if (scroll) {
      setDisplayMainMenu(false);
      dispatch(isHeaderScroll(true));
    }
    else {
      setDisplayMainMenu(true);
      dispatch(isHeaderScroll(false))
    }
  }, [scroll]);

  useEffect(()=>{
    if(accountSidebarOpen && searchActive && !isMobileOrBelow){
      setSearchActive(false)
    }
    //  if icon not selected
    if (isPWA && !isSearchIcon ) {
      setSearchActive(false)
    }
    if (isPWA && !isSearchIcon && !navSidebarOpen ) {
      setSearchActive(false)
    }
  },[searchActive,accountSidebarOpen,navSidebarOpen,isSearchIcon])

  useEffect(() => {
    const getAllItemsFromWishlist = async (HashId) => {
      let wishlistItems;
      let wHashID = localStorage.getItem("wishlistHash");
      let wishItemData = sessionStorage.getItem("wishlist")
      let wishItemDataJson;
      if(wishItemData){
        wishItemDataJson = JSON.parse(wishItemData);
      }

      if(wHashID && wishItemDataJson && wishItemDataJson?.items && wishItemDataJson?.items?.length > 0){
          wishlistItems = wishItemDataJson?.items;
      }else{
        wishlistItems = await getWishlistProducts({ HashId: HashId });
      }

      if (wishlistItems && wishlistItems?.length > 0) return wishlistItems;
      else return [];
    };

    const getWishlist = async (customerId) => {
      dispatch(setWishlistLoadingState(true));
      // Create or Get Wishlist
      let wishlistData;
      if (!localStorage.getItem("wishlistHash")) {
        wishlistData = await createOrGetWishlist();
        // localstorage is set but not used anywhere for wishlist functionality
        localStorage.setItem("wishlistHash", wishlistData);
      } else {
        wishlistData = localStorage.getItem("wishlistHash");
        //SUP-3734 #below is done to update the hash id in case of object object to empty
        if(wishlistData && wishlistData.toLowerCase()=="[object object]") {
          localStorage.setItem("wishlistHash", '');
          wishlistData = '';
        }
      }

      // Get the WishlistItems From API
      const wishlistItems = await getAllItemsFromWishlist(wishlistData);

      sessionStorage.setItem(
        "wishlist",
        JSON.stringify({ items: wishlistItems })
      );

      dispatch(
        initializeWishlist({
          wishlistHashId: wishlistData,
          wishlist: wishlistItems,
        })
      );

      dispatch(setWishlistLoadingState(false));
    };
    // Get The Wishlists From API
    getWishlist();
  }, []);

  const handleTopLinkClick = (linkId) => {
    setActiveTopLink(linkId);
    setDisplayMainMenu(true);
    const linkName = linkId == 1? "Impact" : "Shop";
    navigationTracking("Navigation " + linkName);
  };

  const handleTopLinksHover = (e, linkId) => {
    if (e.type === "mouseenter" && linkId === activeTopLink && scroll) {
      setDisplayMainMenu(true);
    }
    else if (e.type === "mouseleave" && linkId === activeTopLink && scroll) {
      setDisplayMainMenu(false);
    }
  }

  function handleSearchClick() {
    setSearchActive(!searchActive);
  }

  const topLinks = (
    <TopLinks color={accountColor?.fontColor} activeLink={activeTopLink} handleClick={handleTopLinkClick} handleHover={handleTopLinksHover} scroll={scroll} />
  );

  let headerHeight = 0;
  if (
    destopHeaderRef.current !== null &&
    destopHeaderRef.current.offsetHeight
  ) {
    headerHeight += destopHeaderRef.current.offsetHeight;
    headerHeight += destopHeaderRef.current.offsetTop;
  } else if (!scroll && mobileHeaderRef.current !== null && nostoRef.current!==null) {
    headerHeight += mobileHeaderRef.current.offsetHeight;
    headerHeight += nostoRef.current.offsetHeight;
    // headerHeight += mobileHeaderRef.current.offsetTop;
  }else if(scroll && mobileHeaderRef.current !== null){
    headerHeight += mobileHeaderRef.current.offsetHeight;
  }

  // Conditionally rendering either mobile/tablet header or desktop header depending on screen width. Done to fix issue in OS-1511
  const isTabletOrBelow = useMediaQuery("(max-width: 990px)");
  const submenuToggle = useSelector(
    (state) => state.header.isSubmenuVisible
  );
  //checks if first time pwa visitor 
  const visited = useSelector((state) => state.pwa.is_visited);
  
  useEffect(()=>{
    if(isMenuVisible){
      document.getElementById("mob_icons").classList.add("v-xs-none")
      setTimeout(()=>{
        document.getElementById("mob_icons").classList.remove("v-xs-none")
      },500)
    }
  }, [isMenuVisible])
  
  return (
    <>
      {/* Desktop Header */}
      { (
        <>
          <TopBanner isMobile={false} topLinks={topLinks} accountSidebar={<AccountSidebar selectIcon={selectIcon} accountColor={accountColor?.fontColor}/>} selectedIcon={selectedIcon} handleSetAccountColor={handleSetAccountColor}/>
          <div
          style={{
            position: 'relative',
            zIndex: accountSidebarOpen ? 99 : 'auto', // Set zIndex based on accountSidebarOpen
          }}
            className={`mob_hide${superBrandHeroPresent ? " super_brand_desktop" : ""
              }${submenuToggle ? " bg-oat" : ""}`}
          >
           <div
              className={`${scroll ? `${styles.fixed} fixed-header` : ""} ${
                lowerHeaderZIndex ? styles.no_overlap : ""
              } header__main_desk mob_hide ${styles.desk_header_fix_height}`}
              ref={destopHeaderRef}
            >
              <DesktopMainHeader
                handleSearchClick={handleSearchClick}
                selectedIcon={selectedIcon}
                selectIcon={selectIcon}
                topLinks={topLinks}
                scroll={scroll}
                displayMainMenu={displayMainMenu}
              />
              {/* Main menu */}
            </div>
          </div>
        </>
      )}
      <div
        style={{ top: `${headerHeight}px` }}
        className={`backdrop__search`}
        onClick={handleSearchClick}
      />
      <SearchComp
        setSearchActive={setSearchActive}
        selectIcon={selectIcon}
        searchRef={searchRef}
        handleSearchClick={handleSearchClick}
        searchActive={searchActive}
        style={{
          // adding top style conditionally based on search icon and sidbar state
          top: `${(navSidebarOpen && isSearchIcon && isPWA) ? '45' : headerHeight}px`,
          transform: `translateY(calc(-100% - ${headerHeight}px))`,
          zIndex: accountSidebarOpen ? 99 : 9999, //keeping it 9999 because of existing z-index .search__container class.
        }}
      />
      {/* Mobile header */}
      {/* Changes required for mobile header needs to be done for both the duplicate mobile header code blocks. 
          div wrapper is required only for PWA. If applied for site as well it casues OS-4342. That's why header code is added conditionally */}
      { isPWA ? (
        <div id="pwa-mobile-header" className="pwa_mob_wrapper">
          <div ref={nostoRef}>
          <TopBanner isMobile={true} topLinks={topLinks} handleSetAccountColor={handleSetAccountColor} />
          </div>
          <div
            className={`${scroll ? `${styles.fixed} ${styles.pwa_header_fixed} fixed-header` : ""}  ${lowerHeaderZIndex ? styles.no_overlap : ""
              } header__main_mob ${superBrandHeroPresent ? "super_brand_mobile" : ""
              }`}
            ref={mobileHeaderRef}
          >
            <MobileMainHeader
              handleSearchClick={handleSearchClick}
              selectedIcon={selectedIcon}
              selectIcon={selectIcon}
              topLinks={topLinks}
              scroll={scroll}
              showWcJourney={showWcJourney}
              setShowWcJourney={setShowWcJourney}
            />
          </div>
        </div>
      ) : (
        <>
          <div ref={nostoRef}>
            <TopBanner isMobile={true} topLinks={topLinks} handleSetAccountColor={handleSetAccountColor} />
          </div>
          <div
            className={`${scroll ? `${styles.fixed} fixed-header` : ""}  ${lowerHeaderZIndex ? styles.no_overlap : ""
              } header__main_mob ${superBrandHeroPresent ? "super_brand_mobile" : ""
              }`}
            ref={mobileHeaderRef}
          >
            <MobileMainHeader
              handleSearchClick={handleSearchClick}
              selectedIcon={selectedIcon}
              selectIcon={selectIcon}
              topLinks={topLinks}
              scroll={scroll}
              showWcJourney={showWcJourney}
              setShowWcJourney={setShowWcJourney}
            />
          </div>
        </>
      )}
    </>
  );
}
